/* eslint-disable no-useless-catch */
// import { FindOneOptions, FindOptions } from './common';
import { stockService } from './services';

const pathname = '/inventory-items';

export const InventoryItemApi = {
  findInventoryItemWithProduct: async (id: string) => {
    try {
      const url = `${pathname}/product/${id}`;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
